import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { generateTable } from '../../table/Table';
import { fetchTeams } from '../../../apis';
import { defineKqlQuery } from '../../../helpers';
import { generatePaginationParams, generateSortParams } from '../../../apis/http';
var teamQuery = defineKqlQuery().startsWith('name', 'name').end();

var dataSource = function dataSource() {
  return {
    fn: fetchTeams,
    params: function params(paramData) {
      return [_objectSpread(_objectSpread(_objectSpread({}, generateSortParams(paramData)), generatePaginationParams(paramData)), {}, {
        q: teamQuery(paramData.filters.toJS()),
        include: 'authorization,details'
      })];
    },
    transform: function transform(result) {
      return {
        data: result.teams,
        nextPageToken: result.nextPageToken
      };
    }
  };
};

var filters = function filters() {
  return function () {
    return [{
      name: 'name',
      label: 'Name',
      type: 'text'
    }];
  };
};

var columns = [{
  value: 'name',
  title: 'Name',
  sortable: true
}, {
  value: 'updatedAt',
  title: 'Updated',
  sortable: true
}, {
  value: 'createdAt',
  title: 'Created',
  sortable: true
}, {
  value: 'description',
  title: 'Description',
  sortable: true
}, {
  value: 'slug',
  title: 'Slug',
  sortable: true
}];
export var TeamTable = generateTable({
  columns: columns,
  filters: filters,
  dataSource: dataSource
});
TeamTable.displayName = 'TeamTable';